<script setup lang="ts">
import {default as templateStore} from "@/store";
</script>

<script lang="ts">
import {defineComponent} from 'vue'
import {PassBonus} from "@/components/RegistrationPage/Card/PassProperties";
import store from "@/store";

export default defineComponent({
    name: 'BonusDescriptionModal',

    computed: {
        passBonus(): PassBonus
        {
            return store.state.passBonus as PassBonus
        },
    },
})
</script>

<template>
    <div
        class="descriptionModal"
        v-if="templateStore.state.passBonus !== null"
    >
        <div class="background absolute-fill" @click="templateStore.state.passBonus = null"/>

        <div class="content">
            <i class="bi bi-x-lg" @click="templateStore.state.passBonus = null"/>

            <img :alt="passBonus.name" :src="`/img/page/landing/registration/item/${passBonus.image}.png`">
            <div>
                <div class="name">{{ passBonus.name }}</div>
                <div class="description" v-html="passBonus.description"/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.descriptionModal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 90000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.background {
    z-index: 0;
    background: rgba(0, 0, 0, 0.77);
}

.content {
    max-width: 500px;
    background: rgba(0, 0, 0, 1);
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 15px 20px 15px 20px;
    z-index: 100;
    position: relative;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 15px;

    img {
        width: 120px;
        height: 120px;
    }

    .bi {
        position: absolute;
        top: 0;
        right: 4px;
        color: whitesmoke;
        font-size: 20px;
        padding: 10px;
    }
}

.name {
    color: orange;
    font-size: 17px;
}

.description {
    color: white;
    font-size: 15px;
}
</style>
